import { IGetVillageListResponseSchema } from '../../../node/repositories/countryside-search/entities/entities/GetVillageListResponseSchema';
import { getDefaultVillageListRequest } from '../../interfaces/villages';

export const getVillageList = ({ villageList }: IGetVillageListResponseSchema, p: number, isMobile?: boolean) => {
  if (!villageList) {
    return [];
  }
  const pageSize = getDefaultVillageListRequest().pageSize || 25;

  return isMobile ? villageList.slice(pageSize * (p - 1), pageSize * p) : villageList;
};
